import { jsaTime, type OperatorJsaMapItem } from './operatorJsaMap';
export const FORM_PRESENCE_MS = 5 * 60 * 1000;
export const FORM_SITE_RADIUS_M = 500;
export interface FormMapRecord {
  id: string; templateId: string; title: string; categoryId: string;
  latitude: number; longitude: number; wellName: string | null; apiNumber: string | null;
  submittedAt: string; lastSeenAt: string | null; endedAt: string | null;
}
export function formAtSite(record: Pick<FormMapRecord, 'submittedAt' | 'lastSeenAt' | 'endedAt'>, at: number): boolean {
  const seen = jsaTime(record.lastSeenAt), submitted = jsaTime(record.submittedAt), ended = jsaTime(record.endedAt);
  return submitted <= at && (!Number.isFinite(ended) || at < ended)
    && seen <= at && at - seen < FORM_PRESENCE_MS && at - submitted < 24 * 3600000;
}
export function formMapItem(record: FormMapRecord, at: number, history: boolean): OperatorJsaMapItem | null {
  if (jsaTime(record.submittedAt) > at) return null;
  const active = formAtSite(record, at);
  if (!active && !history) return null;
  return { ...record, id: `form:${record.id}`, formTemplateId: record.templateId, formTitle: record.title,
    formCategoryId: record.categoryId, status: active ? 'active' : 'completed', ghost: !active,
    jsaNumber: null, wellId: null, operator: null, jobType: record.title, windDirection: null,
    musterPointLat: null, musterPointLng: null, musterHighlightPath: null,
    musterPointBLat: null, musterPointBLng: null, musterHighlightPathB: null };
}
export function distanceMeters(a: number, b: number, c: number, d: number): number {
  const r = Math.PI / 180, x = Math.sin((c-a)*r/2)**2 + Math.cos(a*r)*Math.cos(c*r)*Math.sin((d-b)*r/2)**2;
  return 6371000 * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(Math.max(0,1-x)));
}
export function incidentDirection(fromLat: number, fromLng: number, lat: number, lng: number) {
  if (![fromLat,fromLng,lat,lng].every(Number.isFinite)) return null;
  if (distanceMeters(fromLat,fromLng,lat,lng) < 1) return null;
  const r=Math.PI/180, delta=(lng-fromLng)*r;
  const bearing=(Math.atan2(Math.sin(delta)*Math.cos(lat*r),Math.cos(fromLat*r)*Math.sin(lat*r)-Math.sin(fromLat*r)*Math.cos(lat*r)*Math.cos(delta))/r+360)%360;
  return { bearing, label: ['N','NE','E','SE','S','SW','W','NW'][Math.round(bearing/45)%8] };
}
